$(document).foundation();

$(function () {
	$("button.submenu-toggle").attr("type", "button");

	$(".menu-box").on('click', function (e) {
		e.preventDefault();
		$("#m-search").removeClass("active");
		$("#mobile-menu").toggleClass("active");
	});

	$(".user-box").on('click', function (e) {
		e.preventDefault();
		$("#mobile-menu").removeClass("active");
		$("#m-search").removeClass("active");
	});

	$(".search-box").on('click', function (e) {
		e.preventDefault();
		$("#mobile-menu").removeClass("active");
		$("#m-search").toggleClass("active");
	});

	$('.shipping tbody tr').on('click', function (e) {
		if (e.target.type !== 'radio') {
			$(':radio', this).trigger('click');
		}
	});

	if ($('#priceFilterFields').length) {
		$('#priceFilterFields').on('keydown', function (e) {
			e.stopPropagation();
		});
		MonitorPriceChange();
	}

	if ($('#showModalAfterLoad').length) {
		$('#showModalAfterLoad').foundation('open');
	};
	$('.srch_text').autocomplete({
		serviceUrl: '/_system/handler.ashx',
		minChars: 3,
		groupBy: 'cat',
		maxHeight: 450,
		width: 'flex',
		preserveInput: true,
		triggerSelectOnValidInput: false,
		preventBadQueries: false,
		formatResultFront: function(suggestion, value) {
			var result = '<div class="' + suggestion.data['css'] + '">';
			if (suggestion.data.hasOwnProperty('img')) {
				result += '<img alt="" src="' + suggestion.data['img'] + '" />'; 
			}
			return result + '</div><a href="' + suggestion.data['url'] + '">';
		},
		formatResultBehind: function(suggestion, value) {
			return suggestion.data.hasOwnProperty('desc') ? '</a> ' + suggestion.data['desc'] : '</a>';
		},
		onSelect: function(suggestion) {
			document.location = suggestion.data['url'];
			$('.srch_text').trigger('blur');
		}
	});
	$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		if (newSize !== oldSize && (newSize === 'large' || oldSize === 'large')) {
			$('.srch_text').trigger('blur');
		}
	});
});